import {
  bridge,
  os,
  native,
} from '@ali/amap-lib';
// 业务代码中

// import immersive from '../js/immersive';
// immersive.isImmersion().then((height) => {
//   if(!height) {
//     return;
//   } // 注意这里要return，如果不return的话，在版本不匹配时，会覆盖掉媒体查询的值
//   document.getElementById('titlebar').style.paddingTop = `${height}px`;
// });
export default {
  isImmersion() {
    return new Promise((resolve) => {
      if (os.android) {
        native.compareDiv('100703', (res) => {
          if (!res) { // 小于 1073
            const obj = {
              action: 'getImmersiveStatusBarHeight',
            };
            bridge.send(obj, (info) => {
              if (info.height) {
                const height = info.height / window.devicePixelRatio;
                resolve(height);
              } else {
                resolve(false); // 兼容await的用法
              }
            });
          } else { // 大于等于 1073
            const obj = {
              action: 'screenSafeArea',
            };
            bridge.send(obj, (info) => {
              if (info.top) {
                const height = info.top / 2;
                resolve(height);
              } else {
                resolve(false); // 兼容await的用法
              }
            });
          }
        });
      }else {
        // 1070 ios支持获取顶部高度
        native.compareDiv('100700', (res) => {
          if (res) {
            const obj = {
              action: 'screenSafeArea',
            };
            bridge.send(obj, (info) => {
              if (info.top) {
                const height = info.top / 2;
                resolve(height);
              } else {
                resolve(false);  // 兼容await的用法
              }
            });
          } else {
            resolve(false); // 兼容await的用法
          }
        });
      }
    });
  },
};